import { InjectionToken } from '@angular/core';

/**
 * Lightweight contract the site-config UI needs from a STOMP websocket service. Both
 * `inside-sites/SiteWebsocket` and `wheere-integrator/IntegratorWebsocketService` already match
 * this shape — providing the right one in `app.config.ts` keeps the dialog scope-agnostic.
 */
export interface SiteConfigWebsocketLike {
  initializeStomp(): Promise<void>;
  /**
   * True once the STOMP CONNECTED frame has been received. `initializeStomp()` resolves as soon
   * as the client is *activated*, not connected — subscribing before this returns true throws
   * inside @stomp/stompjs ("There is no underlying STOMP connection").
   */
  isWebSocketConnected(): boolean;
  subscribe<T = unknown>(topic: string, callback: (message: T) => void): { unsubscribe(): void };
}

export const SITE_CONFIG_WEBSOCKET = new InjectionToken<SiteConfigWebsocketLike>('SITE_CONFIG_WEBSOCKET');
